import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router
  ) { }

  canActivate(): boolean {
    const bearerToken = sessionStorage.getItem("bearerToken") as string;

    if (bearerToken) {
      return true;
    } else {
      this.router.navigate(['home/login']);
      return false;
    }
  }

}